import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { observer } from "mobx-react-lite";
import React from "react";
import { convertTemplateToPlanira } from "../../templates/convertTemplateToPlanira";
import {
  getTemplateFromType,
  useCreatePlanFromTemplate,
} from "../../templates/useCreatePlanFromTemplate";
import { CreatePlan } from "../../ui/Create";
import { FullScreenLoading } from "../../ui/Loading";
import { Screen } from "../../ui/Screen";
import { useApi } from "../apis";

type Props = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  "CreatePlanType"
>;

export const CreatePlanTypeScreen: React.FC<Props> = observer(({ route }) => {
  const createPlanType = route.params.planType;

  const { templatesApi } = useApi();
  const [planTemplateData] = React.useState(
    getTemplateFromType(createPlanType),
  );

  const createPlan = useCreatePlanFromTemplate();

  if (!planTemplateData) {
    // Try to load it through template db
    templatesApi.getById(createPlanType).then(async (model) => {
      if (model) {
        const customTemplate = convertTemplateToPlanira(model.data.template);
        // Create and navigate to plan without adding user
        // Set modules to be kept in creation
        const modulesToCreate =
          customTemplate.sections[1].modules.map((m, i) => ({
            ...m,
            keep: true,
            index: i,
          })) ?? [];

        void model.bumpUsedStats();

        void createPlan(customTemplate, modulesToCreate, customTemplate.title);
      }
    });
  }

  if (!planTemplateData) {
    return <FullScreenLoading />;
  }

  return (
    <Screen noPadding>
      <CreatePlan planTemplateData={planTemplateData} />
    </Screen>
  );
});
